import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { rdsNullParameterIcons, RdsNullParameterOption } from '../models/filter/null-filter.model';

@Pipe({
  name: 'rdsNullParameterOptionIcon',
})
export class NullParameterOptionIconPipe implements PipeTransform {
  transform(option: RdsNullParameterOption): string {
    if (!option) {
      return '';
    }
    return rdsNullParameterIcons[option.type];
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [NullParameterOptionIconPipe],
  declarations: [NullParameterOptionIconPipe],
})
export class RdsNullParameterOptionIconPipeModule {}
